import moment from 'moment';

// eslint-disable-next-line import/prefer-default-export
export const secondsToMinutes = time => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  const secondsFormatted = `0${seconds}`.slice(-2);

  return `${minutes}:${secondsFormatted}`;
};

// timeMask is used to control time input to be in military time format (24-hour)
export const timeMask = (nextState, readonly) => {
  let { value: v } = nextState;
  const hours = +v.split(':')[0];
  if (hours >= 24) {
    v = `${v.substr(0, 1)}_${v.substr(2)}`;
  }

  return {
    ...nextState,
    value: readonly ? '__:__' : v,
  };
};

// Converts standard time to military time format (24-hour)
export const toMilitaryTimeString = (time, format = 'HH:mm') => {
  const simplifiedTime = time?.replace('.','');

  const isMilitaryTime = moment(time, "HH:mm", true).isValid();
  const isStandardTime1 = moment(time, "h:mm:ss A", true).isValid();
  const isStandardTime2 = moment(simplifiedTime, "h:mmA", true).isValid();
  const isStandardTime3 = moment(simplifiedTime, "h:mm A", true).isValid();

  let militaryTime = '';

  switch (true) {
    case isMilitaryTime:
      militaryTime = time;
      break;
    case isStandardTime1:
      militaryTime = moment(time, ["h:mm:ss A"]).format(format);
      break;
    case isStandardTime2:
      militaryTime = moment(simplifiedTime, ["h:mmA"]).format(format);
      break;
    case isStandardTime3:
      militaryTime = moment(simplifiedTime, ["h:mm A"]).format(format);
      break;
    default:
      militaryTime = '';
  }

  return militaryTime;
};
